module.exports = __webpack_public_path__ + "img/telehandlers.a2a741b4.jpg";